import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class PaymentService {
    getPaymentSession(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/session',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getPaymentCheckout(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/checkout',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getPaymentBillingMonth(token, client) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/billingmonth',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                params: {
                    client:client
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getPaymentBillingDay(token, client) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/billingday',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                params: {
                    client:client
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postPaymentSuccess(session_id, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/success',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: {
                    session_id
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postPaymentQuantity(client, quantity, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/quantity',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: {
                    client,
                    quantity
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getPaymentMethods(value, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/methods',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: {
                    value
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postPayment(data, value, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: { ...data, value }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postPaymentDetails(data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/details',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: { ...data }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postComputePrice(data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/computeprice',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: { ...data }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getPaymentNeeded(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/needed',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postPaymentProduct(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/payments/product',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }





}